
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { productList } from "@/api/device";
import { getServiceList } from '@/api/service';
import CustomerDialog from '@/components/CustomerDialog/levelByLevel.vue';
import DialogLveReportDept from '@/components/DeptLev/index.vue';

@Component({
  name: "DeviceSearchItem",
  components: {
    CustomerDialog,
    DialogLveReportDept
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  searchData!: any;

  private brandList = [];
  private authStatusOptions: any = [
    {
      id: "0",
      name: "未授权",
    },
    {
      id: "1",
      name: "已授权",
    },
  ];

  created() {
    this.getBrand("", 1);
    this.getServerList();
  }

  private getBrand(id: string, type: number) {
    let parameters: any = {};
    parameters.company_id = UserModule.getCompanyId;
    parameters.product_type = type;
    productList(parameters)
      .then((res) => {
        if (res.data) {
          this.brandList = res.data.list;
        } else {
          this.brandList = [];
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  private brandChange(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private productChange(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private moduleChange(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }

  private customerVisible = false;
  private editDataCustomer = {};
  private customerReadonly = false;
  private selectedCustomer(val: any) {
    let customerId = '';
    if (parseInt(val.customer_type) === 1) {
      customerId = val.customer_company_id;
    } else {
      customerId = 'p' + val.customer_user_id;
    }
    this.searchData.fields = {};
    this.searchData.fields.id = customerId;
    this.searchData.fields.name = val.name;
    this.searchData.fields.companyLevel = val.company_level;
    this.changeData();
    this.customerVisible = false;
  }
  private customerClose(val: any) {
    this.customerVisible = val
  }
  private clearCustomer() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.searchData.fields.companyLevel = '';
    this.changeData();
  }
  @Watch('customerVisible')
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }

  private servicerOptions = []
  private getServerList() {
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    getServiceList(params).then(res => {
      if (res.data) {
        this.servicerOptions = res.data.list;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }


  // private deptType:any = 2
  private departmentLevVisible=false;
  private departmentLevSelect = {id:0,name:''};
  private selectedDept() {
      // this.deptType = 1;
      this.departmentLevVisible = true;
  } 
  
  private selectDeptLev(value:any) {
    // this.formSearch.deptCustomer = value;
    this.departmentLevSelect = value

  }
  private handleLveReportDeptConfirm() {
    this.departmentLevVisible = false;
    this.searchData.fields = {};
    this.searchData.fields.name =  this.departmentLevSelect.name;
    this.searchData.fields.id =  this.departmentLevSelect.id;
    this.changeData();
  }
  private closeDialogLveReportDept() {
    this.departmentLevVisible = false;

    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
  }


  private clearDept() {
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.changeData();
  }

  private changeData() {
    this.$emit("receiveData", this.searchData);
  }

  private keyupHandle() {
    this.$emit("receiveData", this.searchData, true);
  }
}
